/**
 * Sekme modeli ve grup tipleri.
 *
 * Tipler store'dan ayrı duruyor: saf yardımcılar (tabGroups.ts) bunları kullanıyor ve
 * store da o yardımcıları kullanıyor — tek dosyada olsalardı döngüsel bağımlılık olurdu.
 */
export type TabKind =
  | 'screen'
  | 'report'
  | 'reportDesigner'
  | 'dashboard'
  | 'aireport'
  | 'aiadmin'
  | 'account'
  | 'custom';

export interface TabModel {
  tabId: string;
  kind: TabKind;
  screenId?: string;
  objectId?: string | null;
  screenTypeName?: string | null;
  caption: string;
  iconId?: string | null;
  iconName?: string | null;
  params: Record<string, unknown>;
  pinned?: boolean;
  /** Ait olduğu sekme grubu; gruplanmamışsa null/undefined. */
  groupId?: string | null;
  /** Kullanıcı sekmeye kendi adını verdiyse burada durur; ekran adı değişse de korunur. */
  customCaption?: string | null;
  createdAt: number;
  lastActiveAt: number;
  /** Aynı ekran/raporu tekrar açmak yerine odaklamak için anahtar. */
  uniqueKey: string;
  /**
   * Arka planda açıldı ve henüz bakılmadı (ör. arkadaki sekmede biten SP'nin sonuç sekmesi):
   * sekme çubuğunda işaretlenir, sekmeye geçilince kalkar.
   */
  attention?: boolean;
}

/** Sekme açarken: `activate: false` → sekme arkada açılır, odak değişmez (işaretlenir). */
export interface OpenTabOptions {
  focusExisting?: boolean;
  activate?: boolean;
}

/** Chrome'daki sekme grubu renkleri. */
export type TabGroupColor =
  'grey' | 'blue' | 'red' | 'yellow' | 'green' | 'pink' | 'purple' | 'cyan' | 'orange';

export interface TabGroup {
  groupId: string;
  /** Boş olabilir — Chrome'da adsız grup yalnızca renkli bir nokta olarak görünür. */
  name: string;
  color: TabGroupColor;
  collapsed: boolean;
}

/** Sekmenin çubukta görünen adı: kullanıcının verdiği ad varsa o, yoksa ekran adı. */
export function tabLabel(tab: TabModel): string {
  return tab.customCaption?.trim() || tab.caption;
}
